import styled from 'styled-components'

export const SkipLinkStyled = styled.a`
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;

  &:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
  }
`
